import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import CollectorUninstallPage from 'modules/Collectors/Install/CollectorUninstallPage';
import CollectorInstallPage from 'modules/Collectors/Install/CollectorInstallPage';
import CollectorSuccessPage from 'modules/Collectors/Install/CollectorSuccessPage';
import CollectorUninstallSuccessPage from 'modules/Collectors/Install/CollectorUninstallSuccessPage';
import TIRouteProps from './TIRouteProps';

const CollectorInstallRoute: TIRouteProps = {
  path: '/collector/install',
  component: CollectorInstallPage,
  exact: true,
  title: <FormattedMessage id="collectors.installTitle" />
};
const CollectorSuccessRoute: TIRouteProps = {
  path: '/collector/install/success',
  component: CollectorSuccessPage,
  exact: true,
  title: <FormattedMessage id="collectors.successTitle" />
};
const CollectorUninstallRoute: TIRouteProps = {
  path: '/collector/uninstall',
  component: CollectorUninstallPage,
  exact: true,
  title: <FormattedMessage id="collectors.uninstallTitle" />
};
const CollectorUninstallSuccessRoute: TIRouteProps = {
  path: '/collector/uninstall/success',
  component: CollectorUninstallSuccessPage,
  exact: true,
  title: <FormattedMessage id="collectors.uninstallSuccessTitle" />
};

const collectorRootRoutes: TIRouteProps[] = [
  CollectorInstallRoute,
  CollectorSuccessRoute,
  CollectorUninstallRoute,
  CollectorUninstallSuccessRoute
];

export const CollectorRoutes: React.FC = () => {
  return (
    <Switch>
      {collectorRootRoutes.map((route: TIRouteProps) => (
        <Route
          key={Array.isArray(route.path) ? route.path[0] : route.path}
          {...route}
        />
      ))}
    </Switch>
  );
};
